import React from 'react';
import './DashboardView.less';
import { Auth, Database } from '../../firebaseInit.js';
import { observer } from 'mobx-react';
import DevTools from 'mobx-react-devtools';
import TopBar from '../../app/TopBar/TopBar.jsx';
import Footer from '../../app/Footer/Footer.jsx';

const strings = {
  logout: 'Logout'
};

type Props = {
  children: Object
}

const DashboardView = (props: Props) => {
  const devTools = (__DEV__) ? <DevTools position={ { bottom: 0, right: 20 } } /> : null;
  return (
    <div className="dashboard-view">
      <TopBar />
      { props.children }
      { devTools }
      <Footer />
    </div>
  );
};

export default DashboardView;

//Unit test entry point
export const DashboardViewTest = DashboardView;


/** WEBPACK FOOTER **
 ** ./src/js/views/DashboardView/DashboardView.jsx
 **/